import React from 'react';
import { Checkbox } from 'antd';
import type { CheckboxOptionType } from 'antd/es/checkbox';

interface CustomCheckboxGroupProps {
  style?: React.CSSProperties;
  options: (string | number | CheckboxOptionType)[];
  selectedValues: (string | number | boolean)[];
  onChange: (checkedValues: (string | number | boolean)[]) => void;
}

/**
 * Custom checkbox group component wrapper for Ant Design Checkbox.Group
 *
 * @param style - Optional CSS styles
 * @param options - Array of checkbox options
 * @param selectedValues - Array of currently selected values
 * @param onChange - Callback function when selection changes
 */
const CustomCheckboxGroup: React.FC<CustomCheckboxGroupProps> = ({
  style,
  options,
  selectedValues,
  onChange,
}) => {
  return (
    <Checkbox.Group
      options={options}
      value={selectedValues}
      onChange={onChange}
      style={{ ...style, display: 'flex', flexDirection: 'column', gap: '8px' }}
    />
  );
};

export default CustomCheckboxGroup;
